import { MatxLoadable } from "matx";
import { authRoles } from "../../auth/authRoles";

const Branch = MatxLoadable({
    loader: () =>
        import ("./New")
})

const Routes = [{
    path: "/datasetup/other_payment_types",
    component: Branch,
    auth: authRoles.Payment_Setting
}];

export default Routes;